import React from 'react'
import Navbar from '../../../components/Navbar'
import Footer from '../../../components/Footer'
import floricultureData from './floricultureData'
import { Typography } from '@mui/material'
import ProductShowcase from '../ProductShowcase'

const B = '/machines-images/Cold Stores/Floriculture'
const IMAGES = [
  [`${B}/cold1.jpg`, `${B}/cold.jpg`],
  [`${B}/sidcule.jpg`, `${B}/highrh.jpg`],
  [`${B}/Floriculture12.jpg`, `${B}/Floriculture2.jpg`],
  [`${B}/maldives.jpg`, `${B}/reethi.jpg`],
  [`${B}/Seasons2.jpg`, `${B}/seasons.jpg`],
  [`${B}/akshardham1.jpg`, `${B}/akshardham2.jpg`],
  [`${B}/countryinn.jpg`, `${B}/countryinn.jpg`],
  [`${B}/sibang.jpg`, `${B}/sibang1.jpg`],
  [`${B}/khera.jpg`, `${B}/khera1.jpg`],
  [`${B}/landmark.jpg`, `${B}/landmark1.jpg`],
]

function Floriculture() {
  return (
    <>
      <Navbar />

      <main className='page-shell'>
        <div className='page-title-block'>
          <Typography className='page-title'>Floriculture</Typography>
          <Typography className='page-subtitle'>
            Pre-coolers and temperature-controlled storage for flowers.
          </Typography>
        </div>

        <div className='page-stack'>
          {floricultureData.map((data, index) => (
            <ProductShowcase
              key={index}
              title={data.location}
              images={IMAGES[index]}
              specs={[
                { label: 'Rooms', value: data.rooms },
                { label: 'Room 1', value: data.room1 },
                { label: 'Room 2', value: data.room2 },
                { label: 'Room', value: data.room },
              ]}
            />
          ))}
        </div>
      </main>

      <Footer />
    </>
  )
}

export default Floriculture
